export var Seller;
(function (Seller) {
    Seller["MINNOVI"] = "MINNOVI";
    Seller["DYLOG"] = "DYLOG";
    Seller["BUFFETTI"] = "BUFFETTI";
    Seller["ZENZERO"] = "ZENZERO";
    Seller["DIVES"] = "DIVES";
    Seller["NADIR"] = "NADIR";
    Seller["SOLE24ORE"] = "SOLE24ORE";
    Seller["MINNOVI_DEMO"] = "MINNOVI-DEMO";
})(Seller || (Seller = {}));
export const sellers = Object.values(Seller);
export var InvoiceDestination;
(function (InvoiceDestination) {
    InvoiceDestination["SELLER"] = "SELLER";
    InvoiceDestination["AMMINISTRATORE"] = "AMMINISTRATORE";
})(InvoiceDestination || (InvoiceDestination = {}));
export const invoiceDestinations = Object.values(InvoiceDestination);
export const VOCE_DI_SPESA_FISSA = "SPESA_FISSA";
export const VOCE_DI_SPESA_UTENTI = "SPESA_UTENTI";
export const VOCE_DI_SPESA_CONSUMI = "SPESA_CONSUMI";
